import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ToggleTimerMutationVariables = Types.Exact<{
  data: Types.ToggleTimerInput;
}>;


export type ToggleTimerMutation = { toggleTimer: { success: boolean, errorCode?: string | null, timeLog?: { startTime: string } | null, updatedEntitiesTimeSpent?: Array<{ entityId: string, entityType: Types.TimeLogEntityTypeEnum, parentEntityId?: string | null, parentEntityType?: Types.TimeLogEntityTypeEnum | null, totalTimeSpent?: number | null, selfTimeSpent?: number | null }> | null } };


export const ToggleTimerDocument = /*#__PURE__*/ gql`
    mutation toggleTimer($data: ToggleTimerInput!) {
  toggleTimer(data: $data) {
    success
    errorCode
    timeLog {
      startTime
    }
    updatedEntitiesTimeSpent {
      entityId
      entityType
      parentEntityId
      parentEntityType
      totalTimeSpent
      selfTimeSpent
    }
  }
}
    `;

export function useToggleTimerMutation() {
  return Urql.useMutation<ToggleTimerMutation, ToggleTimerMutationVariables>(ToggleTimerDocument);
};